import React, { useEffect, useState } from "react";
import InputField from "../forms/input-field";
import TextAreaField from "../forms/textarea-field";
import PaymentAddressIcon from "../../assets/icons/admin-customer-icons/payment-address";
import AddButton, { DeleteButton } from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import AddressManagementIcon from "../../assets/icons/admin-customer-icons/address-management";
import ShippingAddressIcon from "../../assets/icons/admin-customer-icons/shipping-address";
import { Form, Formik } from "formik";
import errorToast from "../helper-components/error-toast";
import { useDispatch } from "react-redux";
import {
  adminCustomerUpdateAddressAction,
  adminCustomerUpdateContactPersonAction,
  adminCustomerUpdatePaymentTermsAction,
  discountGroupAction,
  insuranceProviderAction,
} from "../../redux/actions/admin-customer-action";
import LoadingOverlay from "../helper-components/overlay-loading";
import successToast from "../helper-components/success-toast";
import SelectField from "../forms/select-field";
import { priceListAction } from "../../redux/actions/general-action";
import { useNavigate } from "react-router-dom";
import InfoIcon from "../../assets/icons/admin-customer-icons/info-icon";
import { handelLabel } from "./handel-label";
import { handelEnabled } from "./handel-enabled";
import Payment2Icon from "../../assets/icons/admin-customer-icons/payment2-icon";
import { paymentSearchListAction } from "../../redux/actions/settings-action";
import { shouldBeDisplay } from "./shouldBeDisplayed";

function Payment({
  customerId,
  payment,
  page,
  disabled,
  // loading,
  // setLoading,
  setCurrentTab,
  paymentId,
  customization,
}) {
  const [terms, setTerms] = useState(null);
  const [priceList, setPriceList] = useState(null);
  const [discountList, setDiscountList] = useState(null);
  const [customData, setcustomData] = useState([]);

  const [loading, setLoading] = useState(false);

  const localStorageData = JSON.parse(localStorage.getItem("customerAdmin"));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialValues = {
    payment: localStorageData?.payment ?? payment,
  };

  function convertArray(input) {
    return input.map((item) => ({
      value: item.name,
      label: item.name,
      id: item.id,
    }));
  }
  function convertPriceList(input) {
    return input.map((item) => ({
      value: item.price_list_id,
      label: item.price_list_name,
    }));
  }
  function convertDiscountList(input) {
    return input.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  }
  const onSuccess = () => {
    setLoading(false);
    successToast("Saved successfully");
    setCurrentTab("Address");
  };
  const onListSuccess = (data) => {
    const res = convertArray(data.data);
    setTerms(res);
    setLoading(false);
  };
  const onTermsSuccess = (data) => {
    const res = convertArray(data?.data?.list);

    setTerms(res);
    setLoading(false);
  };

  const onPriceSuccess = (data) => {
    const res = convertPriceList(data.data);
    setPriceList(res);
    setLoading(false);
  };
  const onDiscountSuccess = (data) => {
    const res = convertDiscountList(data.data);
    setDiscountList(res);
    setLoading(false);
  };
  const onError = (data) => {
    setLoading(false);
    errorToast(data?.data?.message);
  };
  useEffect(() => {
    if (!loading) {
      setLoading(true);
      dispatch(paymentSearchListAction("", onTermsSuccess, onError));
      // dispatch(insuranceProviderAction(onListSuccess, onError));
      dispatch(priceListAction(onPriceSuccess, onError));
      dispatch(discountGroupAction(onDiscountSuccess, onError));
    }
  }, []);
  const UpdateLocalStorage = ({ values }) => {
    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
      // if (page === "add") {
      if (isInitialRender) {
        setIsInitialRender(false);
        return; // Skip the first render
      }

      console.log("Updating localStorage with values:", values);
      try {
        const existingData =
          JSON.parse(localStorage.getItem("customerAdmin")) || {};
        const updatedData = {
          ...existingData,
          payment: values.payment,
        };
        localStorage.setItem("customerAdmin", JSON.stringify(updatedData));
      } catch (error) {
        console.error("Error updating localStorage:", error);
      }
      // }
    }, [values, isInitialRender]);

    return null;
  };
  const handleDefaultContact = (values, setFieldValue, selectedIndex) => {
    const updatedContact = values.payment.map((item, index) => ({
      ...item,
      cmr_default_contact_persons: index === selectedIndex,
    }));

    setFieldValue("payment", updatedContact);
  };

  const handleDeleteContact = (index, values, setFieldValue, length) => {
    if (length === 1) return errorToast("You need atleast one contact");
    else if (values.payment[index].cmr_default_contact_persons === true) {
      return errorToast("Cannot delete the default contact");
    } else {
      const updatedContact = values.payment.filter((_, i) => i !== index);
      setFieldValue("payment", updatedContact);
    }
  };
  useEffect(() => {
    return () => setLoading(false);
  }, []);
  const onSave = (values, { validateForm, errors, setFieldValue }) => {
  if (loading) return;
    const name = values.payment.cmr_payment_terms;

    if (name) {
      const match = terms.find(item => item.label === name);
      if (match) {
        values.payment.cmr_payment_terms_id = match.id;
      }
    }

    const existingData =
          JSON.parse(localStorage.getItem("customerAdmin")) || {};
    const updatedData = {
      ...existingData,
      payment: values.payment,
    };
    localStorage.setItem("customerAdmin", JSON.stringify(updatedData));

  setLoading(true);

  const payload = {
    paymentTermData: {
      ...values.payment,
      cmr_id: customerId,
    },
  };
  dispatch(
    adminCustomerUpdatePaymentTermsAction(
      payload,
      onSuccess,
      onError
    )
  );
};


  useEffect(() => {
    if (customization) {
      let data = customization.filter((item) => item?.label === "payment");
      setcustomData(data?.[0]?.childrenHeading);
    }
  }, [customization]);

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      // validationSchema={validationSchema}
      onSubmit={onSave}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => (
        <Form
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); // Stop form submit
            }
          }}
        >
          {console.log(
            "........................................................",
            values
          )}
          <LoadingOverlay isLoading={loading} />

          <UpdateLocalStorage values={values} />
          <div className="flex flex-col gap-6 mt-6">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[var(--customer-input-section-icon-from-bg)] to-[var(--customer-input-section-icon-to-bg)] rounded-xl">
                  <Payment2Icon />
                </div>
                <div className="flex flex-col justify-between">
                  <label className="text-[length:var(--customer-bold-fs)] font-[var(--customer-current-nav-fw)]">
                    Payment Terms Configuration
                  </label>
                  <label className="text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)]">
                    Set up payment options and financial terms for this party
                  </label>
                </div>
              </div>
            </div>
            <div
              // key={index}
              className=" p-[34px]  flex flex-col gap-6  rounded-2xl  bg-gradient-to-br from-[var(--customer-input-section-from-bg)] to-blue-[var(--customer-input-section-to-bg)]/0 border-[2px] border-[var(--customer-input-border-color)]"
            >
              <div
                className="grid gap-x-3 gap-y-6  min-w-0"
                style={{
                  gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                }}
              >
                {shouldBeDisplay("cmr_payment_terms", page, customData) && (
                  <div className="col-span-1">
                    <div className="w-full flex flex-col gap-[2px]">
                      <SelectField
                        defaultValue={terms?.find(
                          (option) =>
                            option?.label === values?.payment?.cmr_payment_terms
                        )}
                        label={handelLabel("cmr_payment_terms", customData)}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={handelEnabled(
                          "cmr_payment_terms",
                          page,
                          customData
                        )}
                        errMsgContainerClass="hidden"
                        id={`payment.cmr_relationship`}
                        placeholder={`Select ${handelLabel(
                          "cmr_payment_terms",
                          customData
                        )}`}
                        options={terms}
                        name={`payment.cmr_payment_terms`}
                        isSearchable={true}
                        // isRequired={true}
                      />
                      <label
                        className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                      >
                        Required field - Choose payment duration
                      </label>
                    </div>
                  </div>
                )}
                {shouldBeDisplay("cmr_commitment_limit", page, customData) && (
                  <div className="col-span-1">
                    <div className="w-full flex flex-col gap-[2px]">
                      <InputField
                        errMsgContainerClass="hidden"
                        type="number"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="w-full flex  flex-col gap-2 w-full align-end "
                        name={`payment.cmr_commitment_limit`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_commitment_limit",
                          customData
                        )}`}
                        label={handelLabel("cmr_commitment_limit", customData)}
                        isDisabled={handelEnabled(
                          "cmr_commitment_limit",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                      <label
                        className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                      >
                        Minimum purchase commitment amount
                      </label>
                    </div>
                  </div>
                )}

                {values?.payment?.cmr_payment_terms === "Advance Payment" &&
                  shouldBeDisplay(
                    "cmr_payment_percentage",
                    page,
                    customData
                  ) && (
                    <div className="col-span-1">
                      <div className="w-full flex flex-col gap-[2px]">
                        <InputField
                          errMsgContainerClass="hidden"
                          type="number"
                          // isRequired={true}
                          labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                          parentClass="flex  flex-col gap-2 w-full align-end "
                          name={`payment.cmr_payment_percentage`}
                          placeholder={`Enter ${handelLabel(
                            "cmr_payment_percentage",
                            customData
                          )}`}
                          label={handelLabel(
                            "cmr_payment_percentage",
                            customData
                          )}
                          isDisabled={handelEnabled(
                            "cmr_payment_percentage",
                            page,
                            customData
                          )}
                          defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                          containerClass="w-full h-min"
                        />
                        <label
                          className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                        >
                          Percentage of total amount to be paid in advance
                        </label>
                      </div>
                    </div>
                  )}
                {shouldBeDisplay(
                  "cmr_total_discount_percentage",
                  page,
                  customData
                ) && (
                  <div className="col-span-1">
                    <div className="w-full flex flex-col gap-[2px]">
                      <InputField
                        errMsgContainerClass="hidden"
                        type="number"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`payment.cmr_total_discount_percentage`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_total_discount_percentage",
                          customData
                        )}`}
                        label={handelLabel(
                          "cmr_total_discount_percentage",
                          customData
                        )}
                        isDisabled={handelEnabled(
                          "cmr_total_discount_percentage",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                      <label
                        className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                      >
                        Discount applied to all products
                      </label>
                    </div>
                  </div>
                )}
                {shouldBeDisplay("cmr_credit_limit", page, customData) && (
                  <div className="col-span-1">
                    <div className="w-full flex flex-col gap-[2px]">
                      <InputField
                        errMsgContainerClass="hidden"
                        type="number"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`payment.cmr_credit_limit`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_credit_limit",
                          customData
                        )}`}
                        label={handelLabel("cmr_credit_limit", customData)}
                        isDisabled={handelEnabled(
                          "cmr_credit_limit",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                      <label
                        className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                      >
                        Maximum credit amount for business partners
                      </label>
                    </div>
                  </div>
                )}

                {/* <div className="w-full flex flex-col gap-[2px]">
                    <SelectField
                      defaultValue={priceList?.find(
                        (option) =>
                          option?.value === values?.payment?.cmr_price_list
                      )}
                      label={handelLabel("cmr_price_list", customData)}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      general_color="true"
                      borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                      isContainer={true}
                      containerClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      parentClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      isDisabled={handelEnabled(
                        "cmr_price_list",
                        page,
                        customData
                      )}
                      errMsgContainerClass="hidden"
                      id={`payment.cmr_price_list`}
                      placeholder={`Select ${handelLabel(
                        "cmr_price_list",
                        customData
                      )}`}
                      options={priceList}
                      name={`payment.cmr_price_list`}
                      isSearchable={true}
                      // isRequired={true}
                    />
                    <label
                      className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                    >
                      Pricing category for business partners
                    </label>
                  </div> */}
                {shouldBeDisplay("cmr_discount_group", page, customData) && (
                  <div className="col-span-1">
                    <div className="w-full flex flex-col gap-[2px]">
                      <SelectField
                        defaultValue={discountList?.find(
                          (option) =>
                            option?.value ===
                            values?.payment?.cmr_discount_group
                        )}
                        label={handelLabel("cmr_discount_group", customData)}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={handelEnabled(
                          "cmr_discount_group",
                          page,
                          customData
                        )}
                        errMsgContainerClass="hidden"
                        id={`payment.cmr_discount_group`}
                        placeholder={`Select ${handelLabel(
                          "cmr_discount_group",
                          customData
                        )}`}
                        options={discountList}
                        name={`payment.cmr_discount_group`}
                        isSearchable={true}
                        // isRequired={true}
                      />
                      <label
                        className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                      >
                        Discount structure for business partners
                      </label>
                    </div>
                  </div>
                )}

                {shouldBeDisplay("cmr_price_list", page, customData) && (
                  <div className="col-span-1">
                    {/* {values?.payment?.cmr_payment_terms === "Advance Payment" && ( */}
                    <div className="w-full flex flex-col gap-[2px]">
                      <SelectField
                        defaultValue={priceList?.find(
                          (option) =>
                            option?.value === values?.payment?.cmr_price_list
                        )}
                        label={handelLabel("cmr_price_list", customData)}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={handelEnabled(
                          "cmr_price_list",
                          page,
                          customData
                        )}
                        errMsgContainerClass="hidden"
                        id={`payment.cmr_price_list`}
                        placeholder={`Select ${handelLabel(
                          "cmr_price_list",
                          customData
                        )}`}
                        options={priceList}
                        name={`payment.cmr_price_list`}
                        isSearchable={true}
                        // isRequired={true}
                      />
                      <label
                        className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                      >
                        Pricing category for business partners
                      </label>
                    </div>

                    {/* )} */}
                  </div>
                )}
                {shouldBeDisplay("cmr_effective_price", page, customData) && (
                  <div className="col-span-1">
                    <div className="w-full flex flex-col gap-[2px]">
                      <SelectField
                        defaultValue={priceList?.find(
                          (option) =>
                            option?.value ===
                            values?.payment?.cmr_effective_price
                        )}
                        label={handelLabel("cmr_effective_price", customData)}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={handelEnabled(
                          "cmr_effective_price",
                          page,
                          customData
                        )}
                        errMsgContainerClass="hidden"
                        id={`payment.cmr_effective_price`}
                        placeholder={`Select ${handelLabel(
                          "cmr_effective_price",
                          customData
                        )}`}
                        options={priceList}
                        name={`payment.cmr_effective_price`}
                        isSearchable={true}
                        // isRequired={true}
                      />
                      <label
                        className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                      >
                        The final price list that will be applied after
                        considering all discounts and special terms
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="bg-[var(--customer-input-section-from-bg)] rounded-lg flex flex-col gap-2 p-4">
              <div className="flex gap-2">
                <InfoIcon />
                <label
                  className={`text-[var(--customer-info2-fg)] text-[length:var(--customer-current-nav-fs)] font-[var(--customer-default-fw)] w-full`}
                >
                  About Payment Terms
                </label>
              </div>

              <label
                className={`text-[var(--customer-info2-fg)] text-[length:var(--customer-info-fs)] font-[var(--customer-nav-fw)] w-full`}
              >
                Payment terms and financial settings are applied based on party
                type. For individual customers, only basic payment terms are
                applicable. Business partners have access to all financial
                options including credit limits, price lists, and discount
                structures.
              </label>
            </div>

            {page !== "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-between  sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  onclkFn={async () => navigate("/admin/customer")}
                  text={<span>Cancel</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  // onclkFn={onSave}
                  text={<span>Save</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="submit"
                />
              </div>
            )}
            {/* {page === "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-end sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  // isDisabled={false}
                  // icon={<Save size={14} />}
                  onclkFn={() =>
                    navigate(
                      `/edit-customer-admin/${values?.payment?.cmr_id}`,
                      {
                        state: { tab: "Payment" },
                      }
                    )
                  }
                  text={<span>Edit</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            )} */}
            {page == "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-end sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  // isDisabled={false}
                  // icon={<Save size={14} />}
                  onclkFn={() =>
                    navigate(`/edit-customer-admin/${customerId}`, {
                      state: { tab: "Payment" },
                    })
                  }
                  text={<span>Edit</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default Payment;
